//
// Copyright (c) 2024 Comcast
//

import moment from 'moment-wrapper'
import isEqual from 'lodash/isEqual'

// Form's isEqual is used to calculate pristine state of the form
// (true if all form values are the same as initial values)
// Internal isEqual uses simple '===' to compare values which doesn't
// work for Selects and DateTime fields.
// We also treat '' and null as the same values to set pristine=true
// after editing and clearing value which was initially null.

// TODO: add separate isEqual for different fields
export function customIsEqual (a, b) {
  if (a instanceof moment) {
    a = a.toISOString()
  }
  if (b instanceof moment) {
    b = b.toISOString()
  }

  if ((a === null && b === '') || (a === '' && b === null)) {
    return true
  }

  return isEqual(a, b)
}
